import React from 'react';

const TEMPLATES = [
  {
    id: 'modern',
    name: 'Modern',
    description: 'Blue accents, clean layout',
    preview: (
      <div style={{ fontFamily: 'sans-serif', fontSize: '5px', padding: '6px', lineHeight: '1.4' }}>
        <div style={{ color: '#1d4ed8', fontWeight: 'bold', fontSize: '8px', borderBottom: '1.5px solid #1d4ed8', marginBottom: '3px' }}>Full Name</div>
        <div style={{ color: '#555', marginBottom: '3px', fontSize: '4.5px' }}>email · phone · location</div>
        <div style={{ color: '#1d4ed8', fontWeight: 'bold', borderBottom: '0.5px solid #bfdbfe', marginBottom: '2px' }}>SUMMARY</div>
        <div style={{ color: '#333', marginBottom: '3px' }}>Professional summary text here...</div>
        <div style={{ color: '#1d4ed8', fontWeight: 'bold', borderBottom: '0.5px solid #bfdbfe', marginBottom: '2px' }}>EXPERIENCE</div>
        <div style={{ fontWeight: 'bold' }}>Company Name</div>
        <div style={{ color: '#1d4ed8', fontStyle: 'italic' }}>Job Title · 2020-Present</div>
      </div>
    ),
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Traditional serif, timeless',
    preview: (
      <div style={{ fontFamily: 'Georgia, serif', fontSize: '5px', padding: '6px', lineHeight: '1.4' }}>
        <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '8px', borderBottom: '1.5px solid #111', paddingBottom: '2px', marginBottom: '3px' }}>FULL NAME</div>
        <div style={{ textAlign: 'center', color: '#333', marginBottom: '3px', fontSize: '4.5px' }}>email · phone · location</div>
        <div style={{ fontWeight: 'bold', borderBottom: '0.5px solid #999', marginBottom: '2px' }}>PROFESSIONAL SUMMARY</div>
        <div style={{ marginBottom: '3px' }}>Summary text here...</div>
        <div style={{ fontWeight: 'bold', borderBottom: '0.5px solid #999', marginBottom: '2px' }}>EXPERIENCE</div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold' }}>Company</span><span>2020-Present</span>
        </div>
      </div>
    ),
  },
  {
    id: 'minimal',
    name: 'Minimal',
    description: 'Ultra-compact, fits more',
    preview: (
      <div style={{ fontFamily: 'Helvetica, sans-serif', fontSize: '5px', padding: '5px', lineHeight: '1.3' }}>
        <div style={{ marginBottom: '2px' }}>
          <span style={{ fontWeight: 'bold', fontSize: '7px' }}>Full Name</span>
          <span style={{ color: '#888', marginLeft: '4px', fontSize: '4px' }}>email · phone</span>
        </div>
        <hr style={{ margin: '2px 0', border: 'none', borderTop: '0.5px solid #ccc' }} />
        {['SUMMARY', 'SKILLS', 'EXPERIENCE', 'EDUCATION'].map(s => (
          <div key={s} style={{ display: 'flex', gap: '4px', marginBottom: '2px' }}>
            <div style={{ width: '20px', color: '#888', fontSize: '3.5px', fontWeight: 'bold', flexShrink: 0, paddingTop: '0.5px' }}>{s}</div>
            <div style={{ borderLeft: '0.5px solid #e5e5e5', paddingLeft: '3px', flex: 1, color: '#333' }}>Content here...</div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: 'executive',
    name: 'Executive',
    description: 'Dark header, premium feel',
    preview: (
      <div style={{ fontFamily: 'sans-serif', fontSize: '5px', lineHeight: '1.4', overflow: 'hidden' }}>
        <div style={{ background: '#1a1a2e', color: '#fff', padding: '5px 6px', marginBottom: '4px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '8px', marginBottom: '1px' }}>Full Name</div>
          <div style={{ color: '#aab4c8', fontSize: '4px' }}>email · phone · location</div>
        </div>
        <div style={{ padding: '0 6px' }}>
          <div style={{ fontWeight: 'bold', color: '#1a1a2e', borderBottom: '1px solid #1a1a2e', marginBottom: '2px', fontSize: '4px', letterSpacing: '0.5px' }}>PROFESSIONAL SUMMARY</div>
          <div style={{ marginBottom: '3px', color: '#333' }}>Summary text here...</div>
          <div style={{ fontWeight: 'bold', color: '#1a1a2e', borderBottom: '1px solid #1a1a2e', marginBottom: '2px', fontSize: '4px', letterSpacing: '0.5px' }}>PROFESSIONAL EXPERIENCE</div>
          <div style={{ fontWeight: 'bold' }}>Company Name</div>
        </div>
      </div>
    ),
  },
];

export default function TemplateSelector({ selected, onChange }) {
  return (
    <div>
      <p className="text-xs text-gray-500 mb-3">Choose a template, applies to preview and PDF download</p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {TEMPLATES.map(t => (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            className={`rounded-xl border-2 overflow-hidden text-left transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              selected === t.id
                ? 'border-blue-600 shadow-lg shadow-blue-100'
                : 'border-gray-200 hover:border-gray-400'
            }`}
          >
            {/* Mini preview */}
            <div className="bg-white border-b border-gray-100 h-28 overflow-hidden">
              {t.preview}
            </div>
            {/* Label */}
            <div className={`px-2 py-1.5 ${selected === t.id ? 'bg-blue-600 text-white' : 'bg-gray-50 text-gray-700'}`}>
              <div className="text-xs font-semibold">{t.name}</div>
              <div className={`text-[10px] ${selected === t.id ? 'text-blue-100' : 'text-gray-400'}`}>{t.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
